import { React, useState } from 'react';

import Axios from 'axios';

// Components
import { AuthContext } from '../context/AuthContext';

// Will be turned into the illmatikgaming home page for the default site for illmatikgaming.com

const Home = () => {
  return (
    <div className='text-center mb-auto'>
      <h1>Home Page</h1>
      <h4 className='text-4xl'>Welcome to iLLmatik</h4>
      <p>
        This page is still being developed. Currently only the Armory and Shop
        are available to use.
      </p>
    </div>
  );
};

export default Home;
